<template>
  <div style="width: 100%" class="fill-height">
    <v-container>
      <v-row class="justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <!-- Sticky Header -->
          <div v-if="listView" class="lager-sticky-header">
            <div class="controls-row">
              <v-text-field
                v-model="searchTerm"
                placeholder="Pretraži artikle"
                dense
                outlined
                hide-details
                clearable
                class="filter-select controls-search"
                prepend-inner-icon="mdi-magnify"
                @input="onSearchInput"
                @click:clear="clearSearch"
              ></v-text-field>
              <v-select
                v-if="warehouseModule"
                v-model="itemTypeFilter"
                :items="itemTypeOptions"
                item-text="text"
                item-value="value"
                dense
                outlined
                hide-details
                class="filter-select type-filter"
                @change="applySearch"
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn class="add-item-btn" elevation="0" @click="openaddItemForm">
                <v-icon small class="mr-1">mdi-plus</v-icon>
                Dodaj artikl
              </v-btn>
            </div>
            <div class="lager-thead">
              <div style="width:6%;"></div>
              <div class="lager-thead-cell" style="width:34%;">Naziv artikla</div>
              <div class="lager-thead-cell" style="width:15%;">Šifra</div>
              <div class="lager-thead-cell" style="width:15%;">Barkod</div>
              <div class="lager-thead-cell" style="width:17%;">Vrsta</div>
              <div class="lager-thead-cell" style="width:8%; text-align:center;">Stanje</div>
              <div style="width:5%;"></div>
            </div>
          </div>

          <!-- Items List -->
          <div v-if="listView" class="lager-rows-body" style="position: relative;">
            <div v-if="isLoading" class="loading-overlay-receipts">
              <v-progress-circular
                indeterminate
                size="64"
                class="loading-spinner"
              ></v-progress-circular>
            </div>
            <div
              v-for="(item, i) in paginatedItems"
              :key="i"
              class="lager-row"
              :class="getRowClass(item.status)"
            >
              <div class="lager-row-inner">
                <div class="lager-cell-img" style="width:6%; padding-right:0;">
                  <v-img
                    v-if="item.picture"
                    :src="item.picture"
                    contain
                    height="44"
                    style="border-radius:6px; max-width:44px;"
                  ></v-img>
                  <div v-else style="width:44px; height:44px; border-radius:6px; background:#F1F5F9; margin-right:16px;"></div>
                </div>
                <div class="lager-cell" style="width:34%;">
                  <span class="item-name one-liner-text">{{ $options.filters.capitalize(item.name) }}</span>
                </div>
                <div class="lager-cell" style="width:15%;">{{ item.code }}</div>
                <div class="lager-cell" style="width:15%;">{{ item.barcode || '' }}</div>
                <div class="lager-cell" style="width:17%;">{{ showItemType(item.type) }}</div>
                <div class="lager-cell" style="width:8%; justify-content:center;">
                  <v-chip x-small :class="getStatusChipClass(item.status)">
                    {{ translateStatus(item.status) }}
                  </v-chip>
                </div>
                <div class="lager-cell-actions" style="width:5%;">
                  <v-menu offset-y left>
                    <template #activator="{ on, attrs }">
                      <v-btn icon small v-on="on" v-bind="attrs">
                        <v-icon size="18" color="#94A3B8">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense class="lager-kebab-list">
                      <v-list-item @click="openEditForm(item)" class="lager-menu-item">
                        <v-icon small color="#3989C9" class="mr-2">mdi-pencil</v-icon>
                        <v-list-item-title class="lager-menu-title lager-menu-edit">Uredi</v-list-item-title>
                      </v-list-item>
                      <v-list-item :disabled="item.status !== 'OK'" @click="addItemPrice(item)" class="lager-menu-item">
                        <v-icon small color="#00838F" class="mr-2">mdi-credit-card-plus</v-icon>
                        <v-list-item-title class="lager-menu-title lager-menu-pricelist">Dodaj na cjenik</v-list-item-title>
                      </v-list-item>
                      <v-divider class="my-1"></v-divider>
                      <v-list-item @click="openItemDeleteDialog(item)" class="lager-menu-item">
                        <v-icon small color="#ef4444" class="mr-2">mdi-delete-outline</v-icon>
                        <v-list-item-title class="lager-menu-title lager-menu-delete">Obriši artikl</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>

          <!-- Grid View (Card View) -->
          <div v-else class="d-flex justify-center align-center flex-wrap fill-height ma-0 pa-0">
            <v-card
              class="align-center ma-5"
              v-for="(item, i) in paginatedItems"
              :key="i"
              hover
              height="300"
              width="250"
            >
          <v-img
            height="190"
            width="250"
            v-if="item.picture"
            :src="item.picture"
          >
          </v-img>
          <v-img height="190" width="250" v-else src="@/assets/no-item.jpg">
          </v-img>
          <div class="mr-4 ml-4">
            <div>
              <h3 class="selling-point-title-text one-liner-text">
                {{ $options.filters.capitalize(item.name) }}
              </h3>
              <p class="grey--text mb-1 selling-point-text one-liner-text">
                Status: {{ item.status }}
              </p>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip v-if="!warehouseModule" bottom>
              <template
                v-if="!warehouseModule"
                v-slot:activator="{ on, attrs }"
              >
                <v-btn
                  v-if="!warehouseModule"
                  class="mt-0 pt-0"
                  :x-small="density === 'greater'"
                  v-on="on"
                  v-bind="attrs"
                  icon
                  :disabled="item.status !== 'OK'"
                  @click="addItemPrice(item)"
                  @keypress.enter="addItemPrice(item)"
                >
                  <v-icon>mdi-credit-card-plus</v-icon>
                </v-btn>
              </template>
              <span>Dodaj artikl na cjenik</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  :disabled="item.status === 'PROCESSING'"
                  icon
                  @click="openEditForm(item)"
                  @keypress.enter="openEditForm(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Uredi artikl</span>
            </v-tooltip>
            </v-card-actions>
          </v-card>
        </div>

          <!-- Load More Button -->
          <v-row v-if="hasMoreItems" class="justify-center mt-4 mb-4">
            <v-btn
              class="page-nav-btn-header"
              @click="loadMore"
              :loading="isLoading"
              :disabled="isLoading"
              elevation="2"
            >
              Učitaj više
              <v-icon small class="ml-2">mdi-chevron-down</v-icon>
            </v-btn>
          </v-row>

        </v-col>
      </v-row>
    </v-container>
    <add-item
      v-if="!warehouseModule"
      ref="addItem"
      @refresh="refresh"
    ></add-item>
    <add-wh-item
      v-if="warehouseModule"
      ref="addWhItem"
      @refresh="refresh"
    ></add-wh-item>
    <edit-item
      v-if="!warehouseModule"
      ref="editItem"
      @refresh="refresh"
    ></edit-item>
    <edit-wh-item
      v-if="warehouseModule"
      ref="editWhItem"
      @refresh="refresh"
    ></edit-wh-item>
    <add-pricelist-item v-show="!warehouseModule" ref="addPricelistItem" />
    <add-wh-pricelist-item v-show="warehouseModule" ref="addWhPricelistItem" />

    <!-- Delete item modal -->
    <v-dialog v-model="itemDeleteDialog" max-width="520" @click:outside="itemDeleteDialog = false">
      <v-card class="del-modal-card" style="height: 480px; display: flex; flex-direction: column;">

        <div class="del-modal-header">
          <div class="del-modal-header-gloss"></div>
          <div class="del-modal-header-content">
            <v-icon color="white" size="22" class="mr-2">mdi-delete-outline</v-icon>
            <div>
              <div class="del-modal-title">Brisanje artikla</div>
              <div v-if="itemToDelete" class="del-modal-subtitle">{{ itemToDelete.name }}</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon small @click="itemDeleteDialog = false" class="del-modal-close-btn">
              <v-icon color="white" size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-text class="pt-5 pb-3 px-6" style="flex: 1; overflow-y: auto; min-height: 0;">

          <div v-if="itemDeleteLoading" class="d-flex align-center justify-center py-8">
            <v-progress-circular indeterminate color="#3989C9" size="38" width="3"></v-progress-circular>
            <span class="ml-4 body-2" style="color:#64748b;">Provjera u tijeku...</span>
          </div>

          <template v-else-if="itemDeleteErrorMsg === 'on_pricelist'">
            <div class="del-info-box del-info-box--warn mb-4">
              <v-icon size="20" color="#b45309" class="mr-3 flex-shrink-0">mdi-tag-outline</v-icon>
              <span>Artikl se nalazi na cjeniku. Uklonite ga s cjenika prije brisanja.</span>
            </div>
            <div class="del-table-label">AKTIVAN NA PRODAJNIM MJESTIMA</div>
            <div class="del-table">
              <div v-for="name in itemDeletePricelistLocations" :key="name" class="del-table-row">
                <v-icon size="16" color="#94a3b8" class="mr-2">mdi-store-outline</v-icon>
                <span>{{ name }}</span>
              </div>
            </div>
          </template>

          <template v-else-if="itemDeleteErrorMsg === 'in_warehouse'">
            <div class="del-info-box del-info-box--warn mb-4">
              <v-icon size="20" color="#b45309" class="mr-3 flex-shrink-0">mdi-warehouse</v-icon>
              <span>Artikl se nalazi na skladištu. Obrišite ga sa skladišta pa pokušajte ponovo.</span>
            </div>
            <div class="del-table-label">NALAZI SE NA SKLADIŠTU</div>
            <div class="del-table">
              <div v-for="name in itemDeleteWarehouses" :key="name" class="del-table-row">
                <v-icon size="16" color="#94a3b8" class="mr-2">mdi-package-variant-closed</v-icon>
                <span>{{ name }}</span>
              </div>
            </div>
          </template>

          <div v-else-if="itemDeleteErrorMsg === 'error'" class="del-info-box del-info-box--error">
            <v-icon size="20" color="#b91c1c" class="mr-3">mdi-alert-circle-outline</v-icon>
            <span>Došlo je do greške. Pokušajte ponovo.</span>
          </div>

          <template v-else>
            <div class="del-info-box del-info-box--confirm">
              <v-icon size="20" color="#b91c1c" class="mr-3 flex-shrink-0">mdi-alert-remove-outline</v-icon>
              <span>Ova akcija je <strong>nepovratna</strong>. Artikl će biti trajno obrisan.</span>
            </div>
          </template>

        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pb-5 px-6" style="flex-shrink: 0;">
          <v-spacer></v-spacer>
          <v-btn text class="del-btn-cancel" @click="itemDeleteDialog = false">Zatvori</v-btn>
          <v-btn
            v-if="!itemDeleteErrorMsg"
            elevation="0"
            class="del-btn-delete"
            :loading="itemDeleteLoading"
            :disabled="itemDeleteLoading"
            @click="confirmItemDelete"
          >
            <v-icon small class="mr-2">mdi-delete-outline</v-icon>
            Obriši artikl
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import addItem from '@/modules/company/components/AddItem'
import editItem from '@/modules/company/components/EditItem'
import addWhItem from '@/modules/company/components/AddWhItem'
import editWhItem from '@/modules/company/components/EditWhItem'
import addPricelistItem from '@/modules/point-of-sale/components/AddPricelistItem'
import AddWhPricelistItem from '@/modules/point-of-sale/components/AddWhPricelistItem'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
import { collection, query, orderBy, where, limit, getDocs, startAfter, onSnapshot, doc, getDoc, deleteDoc } from 'firebase/firestore'
import triGram from '@/mixins/trigram'

export default {
  inject: ['showLoader', 'confirm', 'confirmClose', 'hideLoader'],
  mixins: [flow, applicationSettings, barcodeChecker, triGram],
  components: { addItem, editItem, addPricelistItem, AddWhPricelistItem, addWhItem, editWhItem },
  data: () => ({
    loading: false,
    isLoading: false,
    items: [],
    allItems: [],
    avatarSize: 120,
    listeners: [],
    itemListeners: [],
    warehouseModule: false,
    searchEmitDestination: 'lagerSearch',
    lastDocSnapshot: null,
    searchObject: undefined,
    currentQuery: null,
    searchTerm: '',
    searchTimeout: null,
    itemTypeFilter: 'all',
    itemDeleteDialog: false,
    itemDeleteLoading: false,
    itemToDelete: null,
    itemDeleteErrorMsg: '',
    itemDeletePricelistLocations: [],
    itemDeleteWarehouses: [],
    itemTypeOptions: [
      { text: 'Svi artikli', value: 'all' },
      { text: 'Prodajni artikli', value: 'selling' },
      { text: 'Skladišni artikli', value: 'storage' }
    ]
  }),
  mounted () {
    this.items = []
    if (state.getCurrentCompany().warehouse === 'module') {
      this.warehouseModule = true
    }
    this.loadItems()
  },
  computed: {
    listView () {
      return state.isListView()
    },
    paginatedItems () {
      return this.allItems
    },
    hasMoreItems () {
      return this.lastDocSnapshot !== null
    }
  },
  beforeDestroy () {
    this.detachItemListeners()
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        // View changed
      }
    },

    companyId (nv, ov) {
      if (nv !== ov) {
        this.detachListeners()
        this.loadItems()
      }
    }
  },
  methods: {
    onSearchInput () {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.applySearch()
      }, 500)
    },

    clearSearch () {
      this.searchTerm = ''
      this.searchObject = undefined
      this.itemTypeFilter = 'all'
      this.lastDocSnapshot = null
      this.detachItemListeners()
      this.allItems = []
      this.loadItems()
    },

    applySearch () {
      if (this.searchTerm && this.searchTerm.trim().length > 0) {
        const triGramObject = this.triGram(this.searchTerm.trim())
        this.searchObject = { triGramObject }
      } else {
        this.searchObject = undefined
      }
      this.lastDocSnapshot = null
      this.detachItemListeners()
      this.allItems = []
      this.loadItems()
    },

    async refresh (itemId) {
      console.log('[Lager] refresh() called with itemId:', itemId)
      // If an item ID is provided, fetch it and either add or update
      if (itemId) {
        try {
          const itemDocRef = doc(df, `companies/${state.getCurrentCompany().id}/items/${itemId}`)
          const itemSnapshot = await getDoc(itemDocRef)

          if (itemSnapshot.exists()) {
            const itemData = { _id: itemId, id: itemId, ...itemSnapshot.data() }
            console.log('[Lager] Fetched item data:', itemData.name)

            // Check if item already exists in the list (edit scenario)
            const existingIndex = this.allItems.findIndex(item => item.id === itemId)

            if (existingIndex !== -1) {
              // Item exists - this is an edit, update it in place
              console.log('[Lager] Updating existing item at index:', existingIndex)
              this.$set(this.allItems, existingIndex, itemData)
            } else {
              // Item doesn't exist - this is a new item, add to top
              console.log('[Lager] Adding new item to top of list')
              this.allItems.unshift(itemData)

              // Attach listener to the new item
              this.attachItemListener(itemId)

              // Scroll to top to show the new item
              this.$nextTick(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' })
              })
            }
            console.log('[Lager] Total items after refresh:', this.allItems.length)
            return
          } else {
            console.warn('[Lager] Item snapshot does not exist for id:', itemId)
          }
        } catch (error) {
          console.error('[Lager] Error fetching item:', error)
        }
      }

      // Default refresh behavior - reload all items
      this.lastDocSnapshot = null
      this.detachItemListeners()
      this.allItems = []
      await this.loadItems()
    },

    async loadItems () {
      if (this.isLoading) return
      this.isLoading = true

      try {
        const triGramObject = this.searchObject?.triGramObject
        const searchConstraints = []

        if (triGramObject) {
          Object.keys(triGramObject).forEach(name =>
            searchConstraints.push(where(`meta.${name}`, '==', true))
          )
        } else {
          searchConstraints.push(orderBy('name', 'asc'))
        }

        // Add pagination constraint for next page
        if (this.lastDocSnapshot) {
          searchConstraints.push(startAfter(this.lastDocSnapshot))
        }

        searchConstraints.push(limit(10))

        const constraints = [
          collection(df, `companies/${state.getCurrentCompany().id}/items`),
          ...searchConstraints
        ]

        this.currentQuery = query(...constraints)

        const snapshot = await getDocs(this.currentQuery)

        const newItems = []
        snapshot.forEach(docSnapshot => {
          const data = { _id: docSnapshot.id, id: docSnapshot.id, ...docSnapshot.data() }

          // Apply item type filter (only for warehouse module)
          if (this.warehouseModule && this.itemTypeFilter !== 'all') {
            // Check if item has warehouse_units with base unit
            let isSellingItem = false
            if (data.warehouse_units && data.warehouse_units.units && data.warehouse_units.base_unit) {
              const baseUnit = data.warehouse_units.units[data.warehouse_units.base_unit]
              if (baseUnit) {
                isSellingItem = baseUnit.is_selling_item || false
              }
            }

            if (this.itemTypeFilter === 'selling' && !isSellingItem) {
              return // Skip non-selling items
            }
            if (this.itemTypeFilter === 'storage' && isSellingItem) {
              return // Skip selling items
            }
          }

          newItems.push(data)

          // Attach listener to each new item
          this.attachItemListener(docSnapshot.id)
        })

        // Sort new items by name
        newItems.sort((a, b) => a.name.localeCompare(b.name))

        // Add new items to existing list
        this.allItems.push(...newItems)

        if (snapshot.docs.length > 0) {
          this.lastDocSnapshot = snapshot.docs[snapshot.docs.length - 1]
        } else {
          // No more items to load
          this.lastDocSnapshot = null
        }
      } catch (error) {
        console.error('Error loading items:', error)
      } finally {
        this.isLoading = false
      }
    },

    async loadMore () {
      if (!this.hasMoreItems || this.isLoading) return

      const currentItemCount = this.allItems.length
      await this.loadItems()

      // Scroll to the last item before new items (so it appears just below header)
      this.$nextTick(() => {
        const itemCards = document.querySelectorAll('.item-card')
        if (itemCards[currentItemCount - 1]) {
          // Scroll with offset to account for sticky header (64px header + some padding)
          const element = itemCards[currentItemCount - 1]
          const yOffset = -70 // Negative offset to position below header
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      })
    },

    showItemType (itemType) {
      if (itemType) {
        return this.$t(`$vuetify.lager.itemTypes.${itemType.toLowerCase()}`)
      } else {
        return ''
      }
    },

    translateStatus (status) {
      if (!status) return ''
      if (status.toUpperCase() === 'OK' || status.toUpperCase() === 'PROCESSING' || status.toUpperCase() === 'ROTO_OK') {
        return status
      } else {
        return this.$t('$vuetify.errors.errorTitle')
      }
    },

    getStatusTooltip (status) {
      if (!status) return ''
      if (status.toUpperCase() === 'OK' || status.toUpperCase() === 'PROCESSING' || status.toUpperCase() === 'ROTO_OK') {
        return status
      } else if (status.toUpperCase() === 'DUPLICATE') {
        return this.$t('$vuetify.errors.duplicateItem')
      } else {
        return status
      }
    },

    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].associateHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },

    openaddItemForm () {
      if (this.warehouseModule) {
        this.$refs.addWhItem.open()
      } else {
        this.$refs.addItem.open()
      }
    },

    openEditForm (item) {
      if (this.warehouseModule) {
        this.$refs.editWhItem.open(item)
      } else {
        this.$refs.editItem.open(item)
      }
    },

    addItemPrice (item) {
      if (this.warehouseModule) {
        this.$refs.addWhPricelistItem.open(item)
      } else {
        this.$refs.addPricelistItem.open(item)
      }
    },

    getRowClass (status) {
      if (!status) return 'status-failed'
      const s = status.toUpperCase()
      if (s === 'OK' || s === 'ROTO_OK') return 'status-ok'
      if (s === 'PROCESSING') return 'status-warn'
      return 'status-failed'
    },

    getStatusChipClass (status) {
      if (!status) return 'status-chip-failed'
      const s = status.toUpperCase()
      if (s === 'OK' || s === 'ROTO_OK') return 'status-chip-ok'
      if (s === 'PROCESSING') return 'status-chip-warn'
      return 'status-chip-failed'
    },

    attachItemListener (itemId) {
      // Check if listener already exists for this item
      if (this.itemListeners.some(l => l.itemId === itemId)) {
        return
      }

      const itemDocRef = doc(df, `companies/${state.getCurrentCompany().id}/items/${itemId}`)

      const unsubscribe = onSnapshot(itemDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
          const updatedData = { _id: docSnapshot.id, id: docSnapshot.id, ...docSnapshot.data() }

          // Find and update the item in allItems array
          const index = this.allItems.findIndex(item => item.id === itemId)
          if (index !== -1) {
            // Use Vue.set or splice to ensure reactivity
            this.$set(this.allItems, index, updatedData)
          }
        }
      }, (error) => {
        console.error(`Error listening to item ${itemId}:`, error)
      })

      // Store the unsubscribe function with item ID
      this.itemListeners.push({ itemId, unsubscribe })
    },

    detachItemListeners () {
      this.itemListeners.forEach(listener => {
        if (listener && listener.unsubscribe) {
          listener.unsubscribe()
        }
      })
      this.itemListeners = []
    },

    async openItemDeleteDialog (item) {
      this.itemToDelete = item
      this.itemDeleteErrorMsg = ''
      this.itemDeletePricelistLocations = []
      this.itemDeleteWarehouses = []
      this.itemDeleteLoading = true
      this.itemDeleteDialog = true

      try {
        const companyId = state.getCurrentCompany().id
        const itemId = item.id

        // 1. Provjeri je li artikl na cjeniku — compat df.doc().get() da snap.exists bude boolean
        const locsSnap = await getDocs(
          query(collection(df, 'locations'), where('company_id', '==', companyId))
        )
        const locs = locsSnap.docs.map(d => ({ id: d.id, name: d.data().name }))
        const pricelistSnaps = await Promise.all(
          locs.map(loc => df.doc(`location_pricelist/${loc.id}/items/${itemId}`).get())
        )
        const activeLocs = locs.filter((loc, i) => {
          if (!pricelistSnaps[i].exists) return false
          const data = pricelistSnaps[i].data()
          return data && (data.prices || data.name || data.active !== undefined)
        })
        if (activeLocs.length > 0) {
          this.itemDeletePricelistLocations = activeLocs.map(l => l.name || l.id)
          this.itemDeleteErrorMsg = 'on_pricelist'
          return
        }

        // 2. Za warehouse module firme: provjeri extended_items (treba ručno obrisati)
        if (this.warehouseModule) {
          const whSnap = await getDocs(
            query(collection(df, 'warehouses'), where('company_id', '==', companyId), where('status', '==', 'OK'))
          )
          const warehouses = whSnap.docs.map(d => ({ id: d.id, name: d.data().name }))
          const whChecks = await Promise.all(
            warehouses.map(wh => df.doc(`warehouses/${wh.id}/extended_items/${itemId}`).get())
          )
          const activeWhs = warehouses.filter((wh, i) => whChecks[i].exists)
          if (activeWhs.length > 0) {
            this.itemDeleteWarehouses = activeWhs.map(w => w.name || w.id)
            this.itemDeleteErrorMsg = 'in_warehouse'
          }
        }
        // Za ne-warehouse firme location_warehouse se automatski briše pri potvrdi
      } catch (e) {
        console.error('Greška pri provjeri artikla:', e)
        this.itemDeleteErrorMsg = 'error'
      } finally {
        this.itemDeleteLoading = false
      }
    },

    async confirmItemDelete () {
      if (!this.itemToDelete || this.itemDeleteErrorMsg) return
      this.itemDeleteLoading = true
      try {
        const companyId = state.getCurrentCompany().id
        const itemId = this.itemToDelete.id

        // Za ne-warehouse firme: obriši iz location_warehouse za sve lokacije
        if (!this.warehouseModule) {
          const locsSnap = await getDocs(
            query(collection(df, 'locations'), where('company_id', '==', companyId))
          )
          await Promise.all(
            locsSnap.docs.map(async locDoc => {
              const ref = df.doc(`location_warehouse/${locDoc.id}/items/${itemId}`)
              const snap = await ref.get()
              if (snap.exists) await ref.delete()
            })
          )
        }

        await deleteDoc(doc(df, `companies/${companyId}/items/${itemId}`))
        this.allItems = this.allItems.filter(i => i.id !== itemId)
        this.itemDeleteDialog = false
        this.itemToDelete = null
      } catch (e) {
        console.error('Greška pri brisanju artikla:', e)
        this.itemDeleteErrorMsg = 'error'
      } finally {
        this.itemDeleteLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* ── Sticky Header ─────────────────────────────────────────── */
.lager-sticky-header {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 14px 0 0;
  border-left: 3px solid #00BCD4;
  border-bottom: 1px solid #EEF2F5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.controls-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px 16px;
}

.controls-search {
  flex: 1;
  max-width: 320px;
}

.controls-search >>> .v-input__control,
.controls-search >>> .v-input__slot {
  height: 40px !important;
  min-height: 40px !important;
}

.type-filter {
  max-width: 180px;
}

.type-filter >>> .v-input__control,
.type-filter >>> .v-input__slot {
  height: 40px !important;
  min-height: 40px !important;
}

/* filter-select standard border */
.filter-select >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}

.filter-select:hover >>> fieldset {
  border-color: #00BCD4 !important;
}

.filter-select.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: #ffffff !important;
}

/* Add button */
.add-item-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  border-radius: 8px !important;
  height: 40px !important;
  min-height: 40px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  padding: 0 16px !important;
  letter-spacing: 0.2px !important;
}

/* ── Table Head ────────────────────────────────────────────── */
.lager-thead {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EEF2F5;
}

.lager-thead-cell {
  font-size: 11px;
  font-weight: 600;
  color: #94A3B8;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding: 0 8px;
}

/* ── Data Rows ─────────────────────────────────────────────── */
.lager-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.lager-row {
  display: flex;
  align-items: stretch;
  border: 1px solid #EEF2F5;
  border-left: 3px solid #E0E0E0;
  border-radius: 6px;
  background: #ffffff;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
  min-height: 56px;
  margin-bottom: 4px;
  overflow: hidden;
}

.lager-row:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.lager-row.status-ok     { border-left-color: #4ADE80 !important; }
.lager-row.status-warn   { border-left-color: #FBBF24 !important; }
.lager-row.status-failed { border-left-color: #F87171 !important; }

.lager-row-inner {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 60px;
}

.lager-cell-img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  flex-shrink: 0;
}

.lager-cell {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
  padding: 0 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.lager-cell-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  flex-shrink: 0;
}

.item-name {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Status Chips ──────────────────────────────────────────── */
.status-chip-ok {
  background: #DCFCE7 !important;
  color: #166534 !important;
  font-weight: 600 !important;
}

.status-chip-warn {
  background: #FEF9C3 !important;
  color: #854D0E !important;
  font-weight: 600 !important;
}

.status-chip-failed {
  background: #FEE2E2 !important;
  color: #991B1B !important;
  font-weight: 600 !important;
}

/* ── Kebab Menu ────────────────────────────────────────────── */
.lager-kebab-list {
  padding: 4px 0 !important;
  min-width: 160px !important;
}

.lager-menu-item {
  min-height: 36px !important;
  padding: 0 12px !important;
}

.lager-menu-item >>> .v-list-item__content {
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.lager-menu-title {
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1 !important;
}

.lager-menu-edit      { color: #3989C9 !important; }
.lager-menu-pricelist { color: #00838F !important; }
.lager-menu-delete    { color: #ef4444 !important; }

.lager-menu-item.v-list-item--disabled .lager-menu-pricelist,
.lager-menu-item.v-list-item--disabled .v-icon {
  opacity: 0.4 !important;
}

/* ── Load More Button ──────────────────────────────────────── */
.page-nav-btn-header {
  background: #ffffff !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  height: 40px !important;
  padding: 0 20px !important;
}

/* ── Loading Overlay ───────────────────────────────────────── */
.loading-overlay-receipts {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 16px;
  padding: 40px;
}

.loading-spinner {
  color: #00BCD4 !important;
}

/* ── Delete modal ──────────────────────────────────────────── */
.del-modal-card {
  border-radius: 16px !important;
  overflow: hidden !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14) !important;
}
.del-modal-header {
  position: relative;
  padding: 20px 24px;
  background: linear-gradient(135deg, rgba(0,179,190,0.55) 0%, rgba(57,137,201,0.5) 50%, rgba(97,84,164,0.55) 100%);
  overflow: hidden;
}
.del-modal-header-gloss {
  position: absolute; top: 0; left: -100%; width: 60%; height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.18) 50%, transparent 100%);
  pointer-events: none;
}
.del-modal-header-content { position: relative; z-index: 1; display: flex; align-items: center; }
.del-modal-title { color: white !important; font-weight: 700 !important; font-size: 16px !important; letter-spacing: 0.3px; text-shadow: 0 1px 4px rgba(0,0,0,0.15); line-height: 1.3; }
.del-modal-subtitle { color: rgba(255,255,255,0.8) !important; font-size: 12px !important; font-weight: 500 !important; margin-top: 2px; }
.del-modal-close-btn { background: rgba(255,255,255,0.15) !important; }
.del-modal-close-btn:hover { background: rgba(255,255,255,0.25) !important; }
.del-info-box { display: flex; align-items: flex-start; padding: 14px 16px; border-radius: 10px; font-size: 14px; line-height: 1.5; }
.del-info-box--warn    { background: #fffbeb; border: 1px solid #fde68a; color: #78350f; }
.del-info-box--error   { background: #fff1f2; border: 1px solid #fecdd3; color: #7f1d1d; }
.del-info-box--confirm { background: #fff1f2; border: 1px solid #fecdd3; color: #7f1d1d; }
.del-table-label { font-size: 11px; font-weight: 700; color: #3989C9; letter-spacing: 0.6px; margin-bottom: 6px; padding-left: 2px; }
.del-table { border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; }
.del-table-row { display: flex; align-items: center; padding: 10px 14px; font-size: 14px; color: #334155; border-bottom: 1px solid #f1f5f9; }
.del-table-row:last-child { border-bottom: none; }
.del-table-row:nth-child(even) { background: #f8fafc; }
.del-btn-cancel { color: #3989C9 !important; font-weight: 600 !important; font-size: 14px !important; text-transform: none !important; letter-spacing: 0.2px !important; border-radius: 10px !important; height: 42px !important; padding: 0 18px !important; }
.del-btn-delete { background: linear-gradient(135deg, #f43f5e 0%, #dc2626 100%) !important; color: white !important; border-radius: 10px !important; height: 42px !important; padding: 0 22px !important; font-weight: 600 !important; font-size: 14px !important; text-transform: none !important; letter-spacing: 0.3px !important; box-shadow: 0 4px 12px rgba(220,38,38,0.3) !important; }
.del-btn-delete:hover { box-shadow: 0 6px 16px rgba(220,38,38,0.4) !important; }
</style>
